<template>
    <div v-if="!isOnline"
         class="alert alert-danger mb-1">
        <i class="fa-solid fa-exclamation-triangle"></i>&nbsp;
        <span v-if="messageRaw"
              v-html="messageRaw"></span>
        <span v-else>{{ l(message) }}</span>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'OfflineNotification',

    props: {
        // A lang key.
        message: {
            type: String,
            default: 'OFFLINE_ERROR_GENERIC',
        },

        // A string of raw text (including html).
        messageRaw: {
            type: String,
            default: null,
        },
    },

    computed: {
        ...mapState(['isOnline']),
    },
};
</script>
